import styled from "styled-components";
import { ToastContainer as Container } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastContainer = styled(Container)`
  line-height: 1.2;
`